import { render, staticRenderFns } from "./previewBox.vue?vue&type=template&id=46dc6750&scoped=true"
import script from "./previewBox.vue?vue&type=script&lang=js"
export * from "./previewBox.vue?vue&type=script&lang=js"
import style0 from "./previewBox.vue?vue&type=style&index=0&id=46dc6750&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dc6750",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46dc6750')) {
      api.createRecord('46dc6750', component.options)
    } else {
      api.reload('46dc6750', component.options)
    }
    module.hot.accept("./previewBox.vue?vue&type=template&id=46dc6750&scoped=true", function () {
      api.rerender('46dc6750', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/retailer/product/previewBox.vue"
export default component.exports